import React from 'react';
import PropTypes from 'prop-types';
import clone from 'clone';
import Draggable from 'react-draggable';

import OEResizeObserver from '../../lib/components/oe-resize-observer';
import {OEPortal} from '../../lib/components/oe-window';
import OEToolbox from '../../lib/tools/oe-toolbox';

export default class OEDraggable extends React.PureComponent {

    constructor(props) {
        super(props);

        this.position = this.props.position;
        this.size = {w: 0, h: 0};

        this.windowSize = {w: window.innerWidth || document.documentElement.clientWidth, h: window.innerHeight || document.documentElement.clientHeight};

        this.state = {
            position: clone(this.position),
        };

        this.onWindowResized = this.onWindowResized.bind(this);

        this.onResize = this.onResize.bind(this);
        this.onDrag = this.onDrag.bind(this);
        this.onStop = this.onStop.bind(this);
    }

    componentDidMount()    {
        this.updatePosition();
        window.addEventListener('resize', this.onWindowResized);
    }

    componentWillUnmount()    {
        window.removeEventListener('resize', this.onWindowResized);
    }

    componentWillReceiveProps(nextProps) {
        if(!OEToolbox.shallowEqual(nextProps.position, this.props.position))    {
            this.setPosition(nextProps.position);
        }
    }

    onWindowResized()   {
        if(!this.updateWindowSize())    this.updatePosition();
    }

    getConstrainedPos(pos)  {
        if(!this.windowSize)    return pos;
        
        let cPos = {x: 0, y: 0};
        let cSize = this.windowSize;

        let size = this.getSize();
        
        let consPos = clone(pos);
        consPos.x = Math.min(Math.max(cPos.x, consPos.x), cPos.x + cSize.w - size.w - 1);
        consPos.y = Math.min(Math.max(cPos.y, consPos.y), cPos.y + cSize.h - size.h - 1);
        return consPos;
    }

    setPosition(pos, noEvent)   {
        let consPos = this.getConstrainedPos(pos);
        if(this.position.x === consPos.x && this.position.y === consPos.y)  return;
        this.position = consPos;
        this.setState({position: consPos});
        if(!noEvent)    window.dispatchEvent(new CustomEvent('oe-layout-changed'));
        if(this.props.onPositionChanged)    this.props.onPositionChanged(this, this.position);
    }

    updatePosition()    {
        this.setPosition(this.getPosition());
    }
    
    getPosition()    {
        return clone(this.position);
    }
    
    getSize() {
        return clone(this.size);
    }

    updateWindowSize()   {
        let windowSize = this.windowSize;
        this.windowSize = {w: window.innerWidth || document.documentElement.clientWidth, h: window.innerHeight || document.documentElement.clientHeight};
        if(!windowSize || windowSize.w == 0 || windowSize.h == 0)  return false;
        let posScale = {x: this.windowSize.w / windowSize.w, y: this.windowSize.h / windowSize.h};
        let position = this.getPosition();
        position.x *= posScale.x; position.y *= posScale.y;
        this.setPosition(position);
        return true;
    }

    onResize(sender, size)  {
        this.size = size;
        this.updatePosition();
    }

    render() {
        if(this.props.hide) return null;

        return (
            <OEPortal>
                <Draggable
                    bounds={'body'}
                    defaultPosition={this.state.position}
                    handle={this.props.handle}
                    onDrag={this.onDrag}
                    onStop={this.onStop}
                    position={this.state.position}
                >
                    <div className={'draggable-container ' + this.props.className} ref={this.props.onContentRef}>
                        <OEResizeObserver onResize={this.onResize} />
                        {this.props.children}
                    </div>
                </Draggable>
            </OEPortal>
        );
    }

    onDrag(e, u) {
        this.setPosition({x: u.x, y: u.y}, false);
    }

    onStop()    {
        //window.dispatchEvent(new CustomEvent('oe-layout-changed'));
    }
}

OEDraggable.defaultProps = {
    className: '',
    hide: false,
    position: {x: 0, y: 0}
};

OEDraggable.propTypes = {
    className: PropTypes.string,
    hide: PropTypes.bool,
    handle: PropTypes.string,
    position: PropTypes.shape({
        x: PropTypes.number.isRequired,
        y: PropTypes.number.isRequired
    }),
    onPositionChanged: PropTypes.func,
    onContentRef: PropTypes.func
}